import {MdWarning} from 'react-icons/md';
import {
  maintenanceEndTime,
  maintenanceStartTime,
} from '../../../config/constants/maintenance';

export const MaintenanceMailAuth = () => {
  const maintenanceStartTimeHours = maintenanceStartTime.getHours();
  const maintenanceEndTimeMonth = maintenanceEndTime.getMonth() + 1;
  const maintenanceEndTimeDay = maintenanceEndTime.getDate();
  const maintenanceEndTimeHours = maintenanceEndTime.getHours();

  return (
    <div className="text-center mb-12">
      <div className="text-notification font-bold">
        <MdWarning size={16} className="inline-block relative" />
        メンテナンスのお知らせ
      </div>
      <div className="ml-2 text-base text-line text-left">
        {maintenanceEndTimeMonth}/{maintenanceEndTimeDay}&nbsp;
        {maintenanceStartTimeHours}:00~{maintenanceEndTimeHours}
        :00の間、一時的にサービスが繋がりにくい状況が発生する可能性がございます。
        <br />
        ご迷惑をおかけしますがよろしくお願いいたします。
      </div>
    </div>
  );
};
